module.exports = __webpack_public_path__ + "static/img/after_one.eb7a59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/after_one.png
// module id = G2xP
// module chunks = 1